import React from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboardTeacher, faCircle, faUpload, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Row, Table } from "react-bootstrap";

class ExaminationTableItem extends React.Component {
  render() {
    const { t } = this.props;
    let hasInstructions = false;
    for (const i in this.props.ex.examination.instructions) {
      if (this.props.ex.examination.instructions[i].length > 0) {
        hasInstructions = true;
        break;
      }
    }
    const instructionsButton = hasInstructions ? (
      <Button
        className="footer-action-button btn btn-green btn-sm"
        style={{ float: "right" }}
        onClick={this.props.onShowInstructions}
      >
        <FontAwesomeIcon icon={faChalkboardTeacher} />
      </Button>
    ) : (
      ""
    );

    let documents = "";
    if (this.props.runningExamination
        && this.props.runningExamination !== "undefined"
        && this.props.runningExamination.isRunning
        && this.props.runningExamination.instanceId === this.props.ex.instance._id
        && this.props.runningExamination.documents.length > 0){
        const lecturerDocuments = this.props.runningExamination.documents.filter(doc => !doc.submitted);
        const studentDocuments = this.props.runningExamination.documents.filter(doc => doc.submitted);
        const lecturerDocumentsTable = lecturerDocuments.length > 0 ? (
            <div>
                <b>{t("ExaminationAccess.Documents.ExaminationDocuments")}:</b><br />
                <Table size="sm" className="mt-2">
                    <tbody>
                        {lecturerDocuments.map(doc => (
                            <tr>
                                <td>{doc.name}</td>
                                <td>
                                    <div className="floatRight">
                                        <Button href={`${window.lernstickBridgeBaseURL}/documents/${doc.id}`}
                                                target="_blank"
                                                className="btn-green btn-sm">
                                            <FontAwesomeIcon icon={faExternalLinkAlt} />
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        ) : "";
        const studentsDocumentsTable = studentDocuments.length > 0 ? (
            <div className={lecturerDocuments.length > 0 ? "mt-2" : ""}>
                <b>{t("ExaminationAccess.Documents.StudentsDocuments")}:</b><br />
                <Table size="sm" className="mt-2">
                    <tbody>
                    {studentDocuments.map(doc => (
                        <tr>
                            <td>{doc.name}</td>
                            <td>
                                <div className="floatRight">
                                    <Button href={`${window.lernstickBridgeBaseURL}/documents/${doc.id}`}
                                            target="_blank"
                                            className="btn-green btn-sm">
                                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
        ) : "";
        documents = <div>
            {lecturerDocumentsTable}
            {studentsDocumentsTable}
        </div>
    }

    const status = this.props.ex.examination.status;
    let icons;
    let examName;
    let startButton = "";
    switch (status) {
      case 10:
        icons = (
          <FontAwesomeIcon icon={faCircle} className="color-yellow mr-2" />
        );
        examName = (
          <span className="ml-2">{this.props.ex.examination.name}</span>
        );
        break;
      case 11:
        icons = (
          <FontAwesomeIcon icon={faCircle} className="color-green mr-2" />
        );
        examName = (
          <span className="ml-2">{this.props.ex.examination.name}</span>
        );
        startButton = (
          <Button
            className="footer-action-button btn btn-green btn-sm ml-1"
            style={{ float: "right" }}
            disabled={(this.props.runningExamination
            && this.props.runningExamination.instanceId === this.props.ex.instance._id
            && this.props.runningExamination.isRunning
            && this.props.runningExamination.examType !== "web")
            || this.props.startInstanceId === this.props.ex.instance._id}
            onClick={() => this.props.onDownload()}
          >
            {t("ExaminationAccess.StartExam")}
          </Button>
        );
        break;
      default:
        icons = (
          <FontAwesomeIcon icon={faCircle} className="color-black mr-2" />
        );
        examName = (
          <span className="ml-2">{this.props.ex.examination.name}</span>
        );
        break;
    }
    let out;
    if (
      this.props.ex.examinationRestrictions.allowStudentFiles &&
      (status === 1 || (status >= 50 && status <= 53))
    ) {
      out = (
        <Row className="align-items-center mb-1">
          <Col>
            {icons}
            {t("ExaminationAccess.PrependExam")}:{examName}
          </Col>
          <Col>
            {startButton}
            {instructionsButton}
            <Button
              className="footer-action-button btn btn-green btn-sm ml-1"
              style={{ float: "right" }}
              onClick={this.props.onUploadManager}
            >
              <FontAwesomeIcon icon={faUpload} />
            </Button>
          </Col>
        </Row>
      );
    } else {
      out = (
          <>
              <Row className="align-items-center mb-1">
                  <Col>
                      {icons}
                      {t("ExaminationAccess.PrependExam")}:{examName}
                  </Col>
                  <Col>
                      {startButton}
                      {instructionsButton}
                  </Col>
              </Row>
              {documents !== "" ? (<Row className="align-items-center mt-1 mb-1">
                  <Col>
                      {documents}
                  </Col>
              </Row>) : ""}
          </>
      );
    }
    return <>{out}</>;
  }
}

export default withTranslation()(ExaminationTableItem);
